export default {"src":"/app/membership/_next/static/media/right-quote.5f75a0d6.svg","height":23,"width":27,"blurWidth":0,"blurHeight":0};